import script from "./TableNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableNav.vue?vue&type=script&setup=true&lang=ts"

import "./TableNav.vue?vue&type=style&index=0&id=4e1a03a6&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1a03a6"]])

export default __exports__